import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { parseAgreementType, type AgreementTypeSearch } from '@/lib/agreement-type-search';
import { AGREEMENT_TYPE_VALUES, type AgreementType } from '@/features/service-agreements/types';
import { OffersPage } from '@/features/vehicle-service-offers/offers-page';

/** The node's service price lists. Reading them requires `pricing:read`; changing `:write`. */
export const Route = createFileRoute('/_app/vehicle-service-offers')({
  staticData: { featureKey: 'vehicle-service-offers' },
  validateSearch: (search: Record<string, unknown>): AgreementTypeSearch<AgreementType> =>
    parseAgreementType(search, AGREEMENT_TYPE_VALUES),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'vehicle-service-offers',
      permissions: ['pricing:read'],
    }),
  component: Page,
});

const routeApi = getRouteApi('/_app/vehicle-service-offers');

function Page() {
  // Keyed, so a sidebar link to another type lands on it rather than keeping the page's state.
  const { type } = routeApi.useSearch();
  return <OffersPage key={type ?? 'default'} initialType={type} />;
}
